import React, { Fragment } from 'react'

export default function ActionDiv(props) {
    const {hero=null}=props
    return (
        <div className="actionDiv">
           {hero==null && <Fragment><h3>Some superheroes use their powers to help fight daily crime while also combating threats against humanity from supervillains </h3>
            <h3>who are their criminal counterparts. Often at least one of these supervillains will be the superhero's archenemy.</h3>
           <h3> Some long-running superheroes and superheroines such as Superman, Spider-Man, Batman, Wonder Woman, the Hulk</h3>  </Fragment>}
           
        </div>
    )
}
